export interface FooterLinkItem {
  displayName: string;
  redirectUrl: string;
  noFollow?: string;
}

export interface FooterLinkColumn {
  title: string;
  listItems: FooterLinkItem[];
}

export interface FooterSocialProfile {
  key: string;
  imgUrl: string;
  webpImgUrl: string;
  redirectionUrl: string;
}

export interface FooterContentData {
  rbLogoUrl: string;
  aboutUsContent: string;
  copyrightText: string;
  footerLinks: FooterLinkColumn[];
  socialProfiles: FooterSocialProfile[];
}

const RB_LOGO_DATA_URL =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjY2IiB2aWV3Qm94PSIwIDAgMTAwIDY2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBpZD0iTG9nbz1yZWRCdXMiPgo8cGF0aCBpZD0iVmVjdG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTk0LjY4MDYgOC43NDAyQzkyLjE4MDggNC4xNzMzMiA4OC45NjY4IDEuNTYzNjcgODUuNTE0NiAxLjIwNzgxQzUzLjEzNjIgLTEuODE3MDEgMTEuODI5OCA1LjM1OTUyIDMuMzc4MDggMTMuMTI5MUMtMC4zMTIxMTcgMTYuNTA5OCAtMC45NjY4MjkgMjQuNDU3NCAxLjM1NDQyIDM3LjQ0NjNDMi45NjE0NCA0Ni41MjA4IDUuNDYxMjUgNTQuNjQ2MiA1LjUyMDc3IDU1LjAwMjFMNi4wNTY0NCA1Ni43ODE0TDE2LjM1MzMgNTUuNjU0NUMxNy4xODY1IDYxLjIyOTcgMjIuMDA3NiA2NS41IDI3Ljg0MDUgNjUuNUMzNC4yMDkgNjUuNSAzOS40NDY3IDYwLjM0IDM5LjQ0NjcgNTMuOTM0NUMzOS40NDY3IDUzLjYzOCAzOS40NDY3IDUzLjQwMDcgMzkuMzg3MiA1My4xMDQyTDYzLjc5MDEgNTAuMzE2NkM2My43OTAxIDUwLjM3NTkgNjMuNzkwMSA1MC40OTQ1IDYzLjc5MDEgNTAuNTUzOEM2My43OTAxIDU2LjkgNjguOTY4MyA2Mi4xMTkzIDc1LjM5NjQgNjIuMTE5M0M4MS43NjQ5IDYyLjExOTMgODcuMDAyNiA1Ni45NTkzIDg3LjAwMjYgNTAuNTUzOEM4Ny4wMDI2IDQ5LjYwNDkgODYuODgzNiA0OC42NTU5IDg2LjY0NTUgNDcuNzY2M0w5Ny4wNjE0IDQ2LjU4MDFMOTcuNTk3MSA0NS40NTMyQzEwMS43NjMgMzYuOTEyNSAxMDAuMzM1IDE5LjA2MDIgOTQuNjgwNiA4Ljc0MDJaTTI3Ljg0MDUgNjAuOTMzMUMyMy45NzE3IDYwLjkzMzEgMjAuODE3MiA1Ny43ODk3IDIwLjgxNzIgNTMuOTM0NUMyMC44MTcyIDUwLjA3OTQgMjMuOTcxNyA0Ni45MzU5IDI3Ljg0MDUgNDYuOTM1OUMzMS43MDkyIDQ2LjkzNTkgMzQuODYzOCA1MC4wNzk0IDM0Ljg2MzggNTMuOTM0NUMzNC44NjM4IDU3Ljc4OTcgMzEuNzA5MiA2MC45MzMxIDI3Ljg0MDUgNjAuOTMzMVpNNzUuMzM2OSA1Ny42MTE4QzcxLjQ2ODEgNTcuNjExOCA2OC4zMTM2IDU0LjQ2ODMgNjguMzEzNiA1MC42MTMyQzY4LjMxMzYgNDYuNzU4IDcxLjQ2ODEgNDMuNjE0NiA3NS4zMzY5IDQzLjYxNDZDNzkuMjA1NiA0My42MTQ2IDgyLjM2MDEgNDYuNzU4IDgyLjM2MDEgNTAuNjEzMkM4Mi4zNjAxIDU0LjQ2ODMgNzkuMjA1NiA1Ny42MTE4IDc1LjMzNjkgNTcuNjExOFpNOTMuOTA2OSA0Mi4zNjlMODQuNDQzMyA0My40MzY2QzgzLjcyOTEgNDIuNDg3NyA4Mi44MzYzIDQxLjcxNjYgODEuODg0IDQxLjA2NDJDODAuMDM4OSAzOS43NTk0IDc3Ljc3NzEgMzkuMDQ3NyA3NS4zMzY5IDM5LjA0NzdDNzEuNzY1NyAzOS4wNDc3IDY4LjQ5MjEgNDAuNzA4NCA2Ni40MDkgNDMuMjU4N0M2NS43NTQzIDQzLjk3MDQgNjUuMTU5MSA0NC44MDA4IDY0LjU2MzkgNDUuNjkwNEwzOC4xMzczIDQ4LjY1NTlDMzcuODk5MiA0OC4xODE0IDM3LjYwMTYgNDcuNzA3IDM3LjMwNDEgNDcuMjkxOEMzNy4yNDQ1IDQ3LjIzMjUgMzcuMjQ0NSA0Ny4xNzMyIDM3LjE4NSA0Ny4xMTM5QzM1LjA0MjMgNDQuMjY3IDMxLjY0OTcgNDIuMzY5IDI3Ljg0MDUgNDIuMzY5QzI0Ljg2NDUgNDIuMzY5IDIyLjE4NjIgNDMuNDk1OSAyMC4xNjI1IDQ1LjI3NTJDMTguNDM2NCA0Ni42OTg3IDE3LjEyNyA0OC42NTU5IDE2LjM1MzMgNTEuMDI4M0w5LjMzIDUxLjc5OTRDNS41ODAyOSAzOC44MTA0IDIuMzY2MjUgMjAuMjQ2NCA2LjQ3MzA4IDE2LjQ1MDVDMTIuMTI3NCAxMS4yMzEyIDQxLjExMzMgNS4wMDM2NiA2OS40NDQ1IDUuMDAzNjZDNzQuNzQxNyA1LjAwMzY2IDc5Ljk3OTQgNS4yNDA5IDg1LjAzODUgNS43MTUzOEM4Ni45NDMxIDUuOTUyNjIgODguOTY2OCA3Ljc5MTIzIDkwLjY5MjggMTAuOTM0N0M5NS4zMzUzIDE5LjQxNiA5Ni44MjMzIDM0LjcxOCA5My45MDY5IDQyLjM2OVpNMTYuODg4OSAyNS4yMjg0QzE2LjY1MDkgMjUuMDUwNSAxNi4yOTM4IDI0Ljg3MjYgMTUuODE3NiAyNC42OTQ2QzE1LjM0MTQgMjQuNTE2NyAxNC44MDU4IDI0LjQ1NzQgMTQuMjEwNiAyNC40NTc0QzEzLjQ5NjMgMjQuNDU3NCAxMi45MDEyIDI0LjU3NiAxMi4zNjU1IDI0Ljc1MzlDMTEuODg5MyAyNC45OTEyIDExLjQ3MjcgMjUuMjI4NCAxMS4xMTU2IDI1LjU4NDNWMzQuOTU1M0g3LjE4NzMxVjIxLjA3NjdMMTEuMTE1NiAyMC44Mzk1VjIyLjIwMzZMMTIuMzY1NSAyMS40MzI2QzEyLjc4MjEgMjEuMTk1MyAxMy4xOTg4IDIxLjAxNzQgMTMuNzM0NCAyMC44Mzk1QzE0LjI3MDEgMjAuNjYxNSAxNC42ODY3IDIwLjYwMjIgMTUuMTYyOSAyMC42MDIyQzE1LjYzOSAyMC42MDIyIDE1Ljk5NjIgMjAuNjAyMiAxNi4yMzQyIDIwLjY2MTVDMTYuNTMxOCAyMC43MjA4IDE2LjcxMDQgMjAuNzgwMiAxNi44ODg5IDIwLjgzOTVWMjUuMjI4NFpNMjguMDc4NiAyNi43NzA1QzI3LjkgMjUuNzAyOSAyNy40ODM0IDI0LjkzMTkgMjYuODg4MiAyNC4zOTgxQzI2LjI5MyAyMy44NjQzIDI1LjU3ODggMjMuNjI3IDI0LjY4NiAyMy42MjdDMjMuNjc0MSAyMy42MjcgMjIuOTAwNCAyMy45MjM2IDIyLjM2NDcgMjQuNTE2N0MyMS44MjkgMjUuMTA5OCAyMS41MzE0IDI1Ljg4MDggMjEuNDEyNCAyNi44Mjk4SDI4LjA3ODZWMjYuNzcwNVpNMzEuNzY4OCAyOC42MDkxSDIxLjQ3MTlDMjEuNzEgMjkuNzM2IDIyLjEyNjYgMzAuNTY2MyAyMi43ODE0IDMxLjA0MDhDMjMuNDM2MSAzMS41MTUzIDI0LjI2OTMgMzEuODExOCAyNS4yMjE2IDMxLjgxMThDMjUuOTk1NCAzMS44MTE4IDI2LjgyODcgMzEuNjkzMiAyNy43ODEgMzEuNDU2QzI4LjczMzMgMzEuMjE4NyAyOS40NDc1IDMwLjkyMjIgMjkuOTgzMiAzMC41NjYzVjM0LjA2NTZDMjkuNDQ3NSAzNC40MjE1IDI4LjczMzMgMzQuNzE4IDI3LjY2MTkgMzQuODk2QzI2LjY1MDEgMzUuMDczOSAyNS44MTY4IDM1LjE5MjUgMjUuMjIxNiAzNS4xOTI1QzIyLjc4MTQgMzUuMTkyNSAyMC44MTcyIDM0LjU0MDEgMTkuNDQ4MyAzMy4xNzZDMTguMDc5MyAzMS44MTE4IDE3LjM2NTEgMzAuMDMyNSAxNy4zNjUxIDI3Ljc3ODhDMTcuMzY1MSAyNS41MjUgMTguMDc5MyAyMy42ODY0IDE5LjUwNzggMjIuMzIyMkMyMC45MzYzIDIwLjk1ODEgMjIuNjYyMyAyMC4yNDY0IDI0LjgwNSAyMC4yNDY0QzI2Ljk0NzcgMjAuMjQ2NCAyOC42MTQyIDIxLjAxNzQgMjkuODY0MSAyMi41MDAxQzMxLjExNCAyMy45ODI5IDMxLjc2ODggMjYuMDU4OCAzMS43Njg4IDI4LjYwOTFaTTQzLjAxNzkgMzAuNjg0OVYyNC41NzZDNDIuNzc5OCAyNC4yNzk1IDQyLjQyMjcgMjQuMDQyMiA0MS45NDY2IDIzLjg2NDNDNDEuNDcwNCAyMy42ODY0IDQwLjkzNDcgMjMuNTY3NyA0MC4zMzk1IDIzLjU2NzdDMzkuMjY4MiAyMy41Njc3IDM4LjQzNDkgMjMuODY0MyAzNy45NTg4IDI0LjUxNjdDMzcuNDIzMSAyNS4xNjkxIDM3LjE4NSAyNi4xNzc0IDM3LjE4NSAyNy41NDE1QzM3LjE4NSAyOC45NjUgMzcuNDgyNiAyOS45NzMyIDM4LjAxODMgMzAuNjg0OUMzOC41NTQgMzEuMzk2NyAzOS4zMjc3IDMxLjY5MzIgNDAuMjggMzEuNjkzMkM0MC44NzUyIDMxLjY5MzIgNDEuNDEwOSAzMS41NzQ2IDQxLjg4NyAzMS4zOTY3QzQyLjM2MzIgMzEuMjE4NyA0Mi43MjAzIDMwLjk4MTUgNDMuMDE3OSAzMC42ODQ5Wk00Ni44ODY3IDM0Ljk1NTNINDMuOTEwN0w0My4wNzc0IDMzLjY1MDVMNDAuOTk0MiAzNC43NzczQzQwLjgxNTcgMzQuODk2IDQwLjU3NzYgMzQuOTU1MyA0MC4yMjA1IDM1LjAxNDZDMzkuODYzNCAzNS4wNzM5IDM5LjYyNTMgMzUuMDczOSAzOS4zODcyIDM1LjA3MzlDMzcuMzYzNiAzNS4wNzM5IDM1LjgxNjEgMzQuNDIxNSAzNC43NDQ3IDMyLjk5OEMzMy42NzM0IDMxLjYzMzkgMzMuMTM3NyAyOS45MTM5IDMzLjEzNzcgMjcuODM4MUMzMy4xMzc3IDI1LjU4NDMgMzMuNzkyNCAyMy44MDUgMzUuMDQyMyAyMi41MDAxQzM2LjM1MTcgMjEuMTk1MyAzOC4wMTgzIDIwLjU0MjkgNDAuMTAxNSAyMC41NDI5QzQwLjY5NjYgMjAuNTQyOSA0MS4yMzIzIDIwLjYwMjIgNDEuNzA4NSAyMC42NjE1QzQyLjE4NDYgMjAuNzgwMiA0Mi42MDEzIDIwLjg5ODggNDMuMDE3OSAyMS4xOTUzVjE1LjA4NjRINDYuODg2N1YzNC45NTUzWk02MC4yMTkgMjguNjY4NEM2MC4yMTkgMjcuNjYwMSA1OS45MjE0IDI2Ljg4OTEgNTkuMzg1NyAyNi40MTQ2QzU4Ljg1IDI1Ljk0MDEgNTguMDc2MyAyNS43MDI5IDU3LjE4MzUgMjUuNzAyOUg1NC40NDU2VjMxLjYzMzlINTcuNTQwNkM1OC40MzM0IDMxLjYzMzkgNTkuMTQ3NiAzMS4zOTY3IDU5LjU2NDMgMzAuODYyOUM1OS45ODA5IDMwLjM4ODQgNjAuMjE5IDI5LjYxNzQgNjAuMjE5IDI4LjY2ODRaTTU5LjUwNDcgMjEuMTM2QzU5LjUwNDcgMjAuMzY1IDU5LjI2NjcgMTkuNzEyNiA1OC43OTA1IDE5LjIzODFDNTguMzE0NCAxOC43NjM2IDU3LjY1OTYgMTguNTI2NCA1Ni44MjY0IDE4LjUyNjRINTQuNDQ1NlYyMy44NjQzSDU3LjA2NDRDNTcuODM4MiAyMy44NjQzIDU4LjQzMzQgMjMuNjI3IDU4Ljg1IDIzLjE1MjZDNTkuMzI2MiAyMi42MTg4IDU5LjUwNDcgMjEuOTY2NCA1OS41MDQ3IDIxLjEzNlpNNjQuNjIzNCAyOS4yMDIyQzY0LjYyMzQgMzAuOTIyMiA2NC4wODc3IDMyLjM0NTYgNjIuOTU2OSAzMy4zNTM5QzYxLjgyNiAzNC40MjE1IDYwLjM5NzUgMzQuODk2IDU4LjY3MTUgMzQuODk2SDUwLjE2MDJWMTUuMTQ1N0g1OC40OTI5QzYwLjA0MDQgMTUuMTQ1NyA2MS4zNDk4IDE1LjU2MDkgNjIuMzAyMSAxNi40NTA1QzYzLjMxNCAxNy4zNDAyIDYzLjc5MDEgMTguNTI2NCA2My43OTAxIDIwLjA2ODRDNjMuNzkwMSAyMS4zMTM5IDYzLjQ5MjUgMjIuMjYyOSA2Mi44OTczIDIzLjAzMzlDNjIuMzAyMSAyMy44MDUgNjEuNDA5MyAyNC4yMjAxIDYwLjIxOSAyNC4zOTgxQzYxLjQwOTMgMjQuNTc2IDYyLjQyMTIgMjUuMTA5OCA2My4zMTQgMjUuOTQwMUM2NC4yMDY4IDI2Ljc3MDUgNjQuNjIzNCAyNy44MzgxIDY0LjYyMzQgMjkuMjAyMlpNODAuMDk4NCAzNC45NTUzSDc2LjE3MDFWMzMuNDEzMkw3NC41MDM2IDM0LjM2MjJDNzQuMDI3NCAzNC41OTk0IDczLjU1MTMgMzQuODM2NyA3My4wNzUxIDM0Ljk1NTNDNzIuNTk5IDM1LjA3MzkgNzIuMDAzOCAzNS4xOTI1IDcxLjQ2ODEgMzUuMTkyNUM3MC4wOTkyIDM1LjE5MjUgNjkuMDI3OCAzNC43Nzc0IDY4LjE5NDUgMzMuOTQ3QzY3LjQyMDggMzMuMTE2NyA2Ny4wMDQyIDMxLjk4OTggNjcuMDA0MiAzMC41NjYzVjIxLjEzNkg3MC45MzI0VjI5LjY3NjdDNzAuOTMyNCAzMC4yMTA1IDcxLjExMSAzMC42MjU2IDcxLjQ2ODEgMzEuMDQwOEM3MS44MjUyIDMxLjQ1NiA3Mi40MjA0IDMxLjYzMzkgNzMuMTM0NiAzMS42MzM5QzczLjg0ODkgMzEuNjMzOSA3NC40NDQxIDMxLjUxNTMgNzQuOTIwMiAzMS4yMTg3Qzc1LjQ1NTkgMzAuOTIyMiA3NS44MTMgMzAuNjg0OSA3Ni4wNTExIDMwLjM4ODRWMjEuMDc2N0g3OS45Nzk0VjM0Ljk1NTNIODAuMDk4NFpNOTMuNzg3OCAzMC4yMTA1QzkzLjc4NzggMzEuNjkzMiA5My4yNTIyIDMyLjkzODcgOTIuMTgwOCAzMy44ODc3QzkxLjEwOTUgMzQuNzc3MyA4OS43NDA1IDM1LjI1MTggODguMTMzNSAzNS4yNTE4Qzg3LjM1OTcgMzUuMjUxOCA4Ni40NjcgMzUuMTkyNSA4NS40NTUxIDM1LjAxNDZDODQuMzgzOCAzNC44MzY3IDgzLjQ5MSAzNC41NDAxIDgyLjY1NzcgMzQuMTI0OVYzMC42MjU2QzgzLjMxMjQgMzAuOTgxNSA4NC4wMjY3IDMxLjI3ODEgODQuODU5OSAzMS41NzQ2Qzg1LjY5MzIgMzEuODExOCA4Ni41ODYgMzEuOTg5OCA4Ny43MTY5IDMxLjk4OThDODguNDkwNiAzMS45ODk4IDg5LjA4NTggMzEuODcxMiA4OS41NjIgMzEuNjkzMkM5MC4wMzgxIDMxLjQ1NiA5MC4yNzYyIDMxLjEwMDEgOTAuMjc2MiAzMC41MDdDOTAuMjc2MiAzMC4xNTEyIDkwLjA5NzYgMjkuNzk1MyA4OS42ODEgMjkuNTU4MUM4OS4yNjQ0IDI5LjMyMDggODguNjA5NiAyOS4xNDI5IDg3LjU5NzggMjkuMDgzNkM4NS44MTIyIDI4Ljk2NSA4NC42MjE5IDI4LjQ5MDUgODMuOTA3NiAyNy43Nzg4QzgzLjE5MzQgMjcuMDY3IDgyLjgzNjMgMjYuMTE4MSA4Mi44MzYzIDI0LjkzMTlDODIuODM2MyAyMy41Njc3IDgzLjM3MTkgMjIuNTAwMSA4NC40NDMzIDIxLjYxMDVDODUuNTE0NiAyMC43MjA4IDg2Ljg4MzYgMjAuMzA1NyA4OC40MzExIDIwLjMwNTdDODkuMTQ1MyAyMC4zMDU3IDg5Ljg1OTYgMjAuMzY1IDkwLjYzMzMgMjAuNDgzNkM5MS40MDcxIDIwLjYwMjIgOTIuMDYxOCAyMC43MjA4IDkyLjY1NyAyMC45NTgxVjI0LjUxNjdDOTEuOTQyNyAyNC4yMjAxIDkxLjI4OCAyMy45ODI5IDkwLjYzMzMgMjMuODY0M0M4OS45Nzg2IDIzLjc0NTcgODkuMjA0OCAyMy42MjcgODguNDMxMSAyMy42MjdDODcuNzc2NCAyMy42MjcgODcuMzAwMiAyMy43NDU3IDg2Ljk0MzEgMjMuOTIzNkM4Ni41ODYgMjQuMTYwOCA4Ni40MDc0IDI0LjM5ODEgODYuNDA3NCAyNC42MzUzQzg2LjQwNzQgMjUuMTY5MSA4Ni42NDU1IDI1LjUyNSA4Ny4xODEyIDI1LjY0MzZDODcuNjU3MyAyNS44MjE1IDg4LjE5MyAyNS45NDAxIDg4Ljc4ODIgMjUuOTQwMUM5MC40NTQ4IDI2LjA1ODggOTEuNzY0MiAyNi40NzM5IDkyLjU5NzQgMjcuMTg1NkM5My4zNzEyIDI3Ljk1NjcgOTMuNzg3OCAyOC45NjUgOTMuNzg3OCAzMC4yMTA1WiIgZmlsbD0iI0Q2Mzk0MSIvPgo8L2c+Cjwvc3ZnPgo=';

/** Static footer content for the onboarding app (matches redbus.in footer). */
export const defaultFooterProps: FooterContentData = {
  rbLogoUrl: RB_LOGO_DATA_URL,
  aboutUsContent:
    "redBus is the world's largest online bus ticket booking service trusted by over 56+ million happy customers globally. redBus offers bus ticket booking through its website, iOS and Android mobile apps for all major routes.",
  copyrightText: 'Ⓒ 2026 MakeMyTrip (India) Limited. All rights reserved',
  footerLinks: [
    {
      title: 'About redBus',
      listItems: [
        {
          displayName: 'Contact us',
          redirectUrl: 'https://www.redbus.in/info/contactus',
        },
        {
          displayName: 'Sitemap',
          redirectUrl: 'https://www.redbus.in/sitemap.html',
        },
        {
          displayName: 'Offers',
          redirectUrl: 'https://www.redbus.in/offers',
        },
        {
          displayName: 'Careers',
          redirectUrl: 'https://www.redbus.in/careers',
        },
      ],
    },
    {
      title: 'Info',
      listItems: [
        {
          displayName: 'T&C',
          redirectUrl: 'https://www.redbus.in/info/termscondition',
        },
        {
          displayName: 'Privacy policy',
          redirectUrl: 'https://www.redbus.in/info/privacypolicy',
        },
        {
          displayName: 'Blog',
          redirectUrl: 'https://blog.redbus.in',
        },
        {
          displayName: 'Bus operator registration',
          redirectUrl: 'https://onboardvendor.redbus.in/',
        },
        {
          displayName: 'Agent registration',
          redirectUrl: 'https://in3.seatseller.travel/',
        },
        {
          displayName: 'Insurance partner',
          redirectUrl: 'https://www.acko.com/',
        },
        {
          displayName: 'User agreement',
          redirectUrl: 'https://www.redbus.in/info/useragreement',
        },
        {
          displayName: 'Primo Bus',
          redirectUrl: 'https://www.redbus.in/primo/primo-service',
        },
        {
          displayName: 'Bus Timetable',
          redirectUrl: 'https://www.redbus.in/bus-timetable',
        },
        {
          displayName: 'Report Security Issues',
          redirectUrl: 'https://www.redbus.in/bugbounty',
        },
      ],
    },
    {
      title: 'Global Sites',
      listItems: [
        {
          displayName: 'India',
          redirectUrl: 'https://www.redbus.in/',
        },
        {
          displayName: 'Singapore',
          redirectUrl: 'https://www.redbus.sg/',
        },
        {
          displayName: 'Malaysia',
          redirectUrl: 'https://www.redbus.my/',
        },
        {
          displayName: 'Indonesia',
          redirectUrl: 'https://www.redbus.id/',
        },
        {
          displayName: 'Peru',
          redirectUrl: 'https://www.redbus.pe/',
        },
        {
          displayName: 'Colombia',
          redirectUrl: 'https://www.redbus.co/',
        },
        {
          displayName: 'Cambodia',
          redirectUrl: 'https://www.redbus.com.kh/',
        },
        {
          displayName: 'Vietnam',
          redirectUrl: 'https://www.redbus.vn/',
        },
      ],
    },
    {
      title: 'Our Partners',
      listItems: [
        {
          displayName: 'Goibibo Bus',
          redirectUrl: 'https://www.goibibo.com/bus/',
        },
        {
          displayName: 'Goibibo Hotels',
          redirectUrl: 'https://www.goibibo.com/hotels/',
        },
        {
          displayName: 'Makemytrip Hotels',
          redirectUrl: 'https://www.makemytrip.com/hotels/',
        },
      ],
    },
  ],
  socialProfiles: [
    {
      key: 'redbus_facebook',
      imgUrl: 'https://s3.rdbuz.com/web/images/layout/social_facebook_new.svg',
      webpImgUrl: 'https://s3.rdbuz.com/web/images/layout/social_facebook_new.webp',
      redirectionUrl: 'https://www.facebook.com/redbus.in/',
    },
    {
      key: 'redbus_linkedin',
      imgUrl: 'https://s3.rdbuz.com/web/images/layout/social_linkedin_new.svg',
      webpImgUrl: 'https://s3.rdbuz.com/web/images/layout/social_linkedin_new.webp',
      redirectionUrl: 'https://in.linkedin.com/company/redbus_2/',
    },
    {
      key: 'redbus_twitter',
      imgUrl: 'https://s3.rdbuz.com/web/images/layout/social_twitter_new.svg',
      webpImgUrl: 'https://s3.rdbuz.com/web/images/layout/social_x_new.webp',
      redirectionUrl: 'https://twitter.com/redBus_in/',
    },
    {
      key: 'redbus_instagram',
      imgUrl: 'https://s3.rdbuz.com/web/images/layout/social_instagram_new.svg',
      webpImgUrl: 'https://s3.rdbuz.com/web/images/layout/social_instagram_new.webp',
      redirectionUrl: 'https://www.instagram.com/accounts/login/?next=/redbusindia/',
    },
  ],
};
